module.exports = __webpack_public_path__ + "static/media/balance.90cc8ab6.svg";